// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--N0lsh","icon":"_4f720283bf--icon--zCbCD","message":"_4f720283bf--message--V3Qki","link":"_4f720283bf--link--EUZY_"};